import { inject, Injectable } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { NonNullableFormBuilder, Validators } from '@angular/forms';
import { DEFAULT_USA_PHONE_PREFIX } from '@app/core/constants/countries-phone-prefix';
import { TrustRequestedAction } from '@app/trust/features/dashboard/shared/enums';
import { FILTER_PATTERNS } from '@shared/constants';
import { map, tap } from 'rxjs';

@Injectable()
export class RegisterTrustFormService {
  private readonly _fb = inject(NonNullableFormBuilder);

  public readonly form = this._fb.group({
    userId: this._fb.control(0),

    email: this._fb.control('', {
      validators: [Validators.pattern(FILTER_PATTERNS.email)],
    }),
    isFirm: this._fb.control(false),

    firstName: this._fb.control('', {
      validators: [
        Validators.required,
        Validators.minLength(2),
        Validators.pattern(FILTER_PATTERNS.name),
      ],
    }),
    middleName: this._fb.control('', {
      validators: [Validators.pattern(FILTER_PATTERNS.name)],
    }),
    lastName: this._fb.control('', {
      validators: [
        Validators.required,
        Validators.minLength(2),
        Validators.pattern(FILTER_PATTERNS.name),
      ],
    }),
    phoneNumber: this._fb.control('', {
      validators: [Validators.pattern(FILTER_PATTERNS.phoneNumberFormatted)],
    }),
    username: this._fb.control('', {
      validators: [Validators.required, Validators.minLength(2)],
    }),
    prefixPhone: this._fb.control<string>(DEFAULT_USA_PHONE_PREFIX),
    requestedAction: this._fb.control<'' | TrustRequestedAction>('', {
      validators: [Validators.required],
    }),
    associatedCaseFileNumber: this._fb.control<string>('', {
      validators: [
        Validators.required,
        Validators.pattern(FILTER_PATTERNS.caseFileNumber),
      ],
    }),
  });

  public readonly isFirm = toSignal(
    this.form.controls.isFirm.valueChanges.pipe(map((isFirm) => !!isFirm)),
    {
      initialValue: false,
    },
  );

  constructor() {
    this.form.controls.isFirm.valueChanges
      .pipe(
        tap((isFirm: boolean) => {
          if (isFirm) {
            this.form.controls.lastName.disable();
            this.form.controls.middleName.disable();

            this.form.controls.lastName.setValue('');
            this.form.controls.middleName.setValue('');
          } else {
            this.form.controls.lastName.enable();
            this.form.controls.middleName.enable();
            this.form.controls.prefixPhone.enable();
          }
          this.form.updateValueAndValidity();
        }),
        takeUntilDestroyed(),
      )
      .subscribe();
  }
}
